import {useCallback} from 'react';

import {useDispatch} from 'react-redux';
import {graphql, useMutation} from 'react-relay';
import {Disposable} from 'relay-runtime';

import {restoreUserMutation} from '../../graphql/__generated__/restoreUserMutation.graphql';

import {setApiFeedback} from '../../state/common/actions';

const mutation = graphql`
  mutation restoreUserMutation {
    restoreUser(input: {}) {
      clientMutationId
    }
  }
`;

function useRestoreUser(): [(callback: () => void) => Disposable] {
  const dispatch = useDispatch();
  const [commit] = useMutation<restoreUserMutation>(mutation);
  return [
    useCallback(
      (callback) => {
        return commit({
          variables: {},
          onCompleted(response) {
            if (response.restoreUser === null) {
              dispatch(setApiFeedback({message: 'Log out request failed'}));
              console.error(new Error('no response from mutation'));
              return;
            }
            callback();
          },
          onError: (e) => {
            dispatch(setApiFeedback({message: 'Log out request failed'}));
            console.error(e);
          },
        });
      },
      [commit],
    ),
  ];
}

export default useRestoreUser;
